import Home from './HomeUserSupplierPage';

export default Home;
